<table class="table">
    <thead>
        <tr>
            <th *ngFor="let col of colItems$ | async">
                <ng-container *ngIf="col.columnContent">
                    <ng-container *ngTemplateOutlet="col.columnContent">
                    </ng-container>
                </ng-container>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let row of rowItems$ | async">
            <td *ngFor="let cell of row.cellItems$ | async">
                <ng-container *ngIf="cell.cellContent">
                    <ng-container *ngTemplateOutlet="cell.cellContent">
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </tbody>
</table>